import {ShellBase} from '@/entryPoints/lib/shell-base';

class Shell extends ShellBase {
  constructor(pageComponents = {}) {
    super(pageComponents);
  }
}

export {Shell};
